import { render, staticRenderFns } from "./Erro404View.vue?vue&type=template&id=2c51acdf&"
import script from "./Erro404View.vue?vue&type=script&lang=js&"
export * from "./Erro404View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports